
import { Options, mixins } from 'vue-class-component'
import { maska } from 'maska'
import { ACTION_STORY } from '@/store/actions'
import { Watch } from 'vue-property-decorator'

import CLoading from '@/components/common/ui/CLoading.vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'
import { constant } from '@/utils/constants'
import BaseFormMixin from '../common/mixins/BaseFormMixin.vue'
import ScenrioReportConditionSelector from '@/components/story/common/selectors/ScenrioReportConditionSelector.vue'
import OpenGraphModal from '@/components/story/common/OpenGraphModal.vue'

import cloneDeep from 'lodash/cloneDeep'

@Options({
  components: {
    ScenrioReportConditionSelector,
    CLoading,
    TestModeSelector,

    OpenGraphModal,
  },
  directives: { maska },
})
export default class ScenarioReport extends mixins(BaseFormMixin) {
  modalVisible = false

  loading = false
  qaReports = []
  answerReports: {
    answer_id: string
    answer_name: string
    answer_id_count: number
    goal_count: number
    conversion_count: number
    items: []
  }[] = []

  detailAnswers = []
  componentKeyDetailAnswers = 0
  componentKeyAnswers = 0
  detailType = 'answer'

  queryParams = {}

  isTestMode = false
  pagination = {
    sortBy: '',
    descending: false,
    page: 1,
    rowsPerPage: 10,
    // rowsNumber: 10,
  }

  selectedChartType = 'daily'
  chartTypeOptions = [
    {
      label: '日別',
      value: 'daily',
    },
    {
      label: '期間合計',
      value: 'period',
    },
  ]

  selectedDetailRow: {
    created_at?: string
    answer_id?: string
    answer_name?: string
  } = {}

  selectedChartRow: {
    created_at?: string
    resource_id?: string
    resource_id_count?: number
    answer_id_count?: number
    answers?: []
    user_answers?: []
  } = {}

  selectedQARow = {}

  get awnserReportTableColumns(): {
    name: string
    label?: string
    field?: string
    width?: string
    align?: string
    sortable?: boolean
  }[] {
    if (this.detailType === 'answer') {
      return [
        {
          name: 'answer_name',
          label: '回答',
          field: 'answer_name',
          align: 'left',
          sortable: true,
          width: '200px',
        },
        {
          name: 'answer_id_count',
          label: '回答数/人',
          field: 'answer_id_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'answer_id_count_progress',
          field: 'answer_id_count_progress',
          align: 'left',
          sortable: true,
        },
        {
          name: 'goal_count',
          label: 'ゴール数/人',
          field: 'goal_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'conversion_count',
          label: 'コンバージョン数/人',
          field: 'conversion_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'action',
          align: 'right',
          width: '100px',
        },
      ]
    } else {
      return [
        {
          name: 'answer_name',
          label: '回答ユーザー',
          field: 'answer_name',
          align: 'left',
          sortable: true,
          width: '200px',
        },
        {
          name: 'answer_id_count',
          label: '回答数/回',
          field: 'answer_id_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'answer_id_count_progress',
          align: 'left',
          sortable: true,
        },
        {
          label: 'ゴール数/回',
          name: 'goal_count',
          field: 'goal_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'conversion_count',
          label: 'コンバージョン数/回',
          field: 'conversion_count',
          align: 'right',
          sortable: true,
        },
        {
          name: 'action',
          align: 'right',
          width: '100px',
        },
      ]
    }
  }

  get rowPerPageOptions() {
    return constant.ROW_PER_PAGE_OPTIONS
  }

  get selectedAppId() {
    return this.$route.params.app_id as string
  }

  get stories() {
    return cloneDeep(this.$store.getters.stories) || []
  }

  isSelectedRow(row) {
    if (
      this.selectedChartRow &&
      this.selectedChartRow.created_at === row.created_at &&
      this.selectedChartRow.resource_id === row.resource_id
    ) {
      return 'btn-save'
    }
    return 'btn-save-grey'
  }

  isSelectedDetailRow(row) {
    if (
      this.selectedDetailRow &&
      this.selectedDetailRow.created_at === row.created_at &&
      this.selectedDetailRow.answer_id === row.answer_id &&
      this.selectedDetailRow.answer_name === row.answer_name
    ) {
      return 'btn-save'
    }
    return 'btn-save-grey'
  }

  @Watch('selectedAppId', { immediate: true })
  async updateApi() {
    if (!this.selectedAppId) {
      return
    }
    this.loading = true
    await this.$store.dispatch(ACTION_STORY.LOAD_ITEMS, {
      app_id: this.selectedAppId,
    })
  }

  async updateQueryParams(params) {
    this.queryParams = params
    await this.loadData()
  }

  resetData() {
    this.qaReports = []
    this.answerReports = []
    this.detailAnswers = []
    this.selectedChartRow = {}
    this.selectedChartType = 'daily'
    this.selectedDetailRow = {}
    this.selectedQARow = {}
  }

  @Watch('isTestMode')
  async loadData() {
    this.loading = true
    this.resetData()
    const returnedData = await this.$store.dispatch(ACTION_STORY.REPORT, {
      app_id: this.selectedAppId,
      is_test_mode: this.isTestMode,
      filter: this.queryParams,
    })

    if (returnedData) {
      // eslint-disable-next-line
      this.qaReports = returnedData['qa_reports']
    }

    this.loading = false
  }

  getLinearProgress(data) {
    let v = 0
    if (this.selectedChartRow && this.selectedChartRow.answer_id_count && this.selectedChartRow.answer_id_count !== 0) {
      v = data.answer_id_count / this.selectedChartRow.answer_id_count
    }
    return v
  }

  onEditStory(data) {
    this.goto('story_setting', {
      app_id: this.selectedAppId,
      story_id: data.story_id,
      action_type: constant.ACTION_TYPE.EDIT,
    })
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  onSelectedChartType(val) {
    console.log(val, 'onSelectedChartType')
    this.answerReports = []
    this.detailAnswers = []
    this.selectedDetailRow = {}
    if (val === 'daily') {
      if (this.selectedChartRow) {
        if (this.detailType === 'answer') {
          this.answerReports = this.selectedChartRow.answers ?? []
        } else {
          this.answerReports = this.selectedChartRow.user_answers ?? []
        }
      }
    } else {
      // Loop through each qaReport
      for (const row of this.qaReports) {
        // eslint-disable-next-line
        if (row['resource_id'] === this.selectedChartRow.resource_id) {
          let rowAnswers: {
            answer_id: string
            answer_name: string
            answer_id_count: number
            goal_count: number
            conversion_count: number
            items: []
          }[]
          if (this.detailType === 'answer') {
            // eslint-disable-next-line
            rowAnswers = row['answers']
          } else {
            // eslint-disable-next-line
            rowAnswers = row['user_answers']
          }
          console.log(rowAnswers, " row['answers']")

          for (const answer of rowAnswers) {
            const existingAnswer = this.answerReports.find((a) => a.answer_id === answer.answer_id)
            if (existingAnswer) {
              existingAnswer.answer_id_count += answer.answer_id_count
              existingAnswer.goal_count += answer.goal_count
              existingAnswer.conversion_count += answer.conversion_count
              existingAnswer.items.push(...cloneDeep(answer.items))
            } else {
              this.answerReports.push(cloneDeep(answer))
            }
          }
        }
      }
    }

    this.componentKeyAnswers++
  }

  onDetailQAs(data) {
    this.selectedDetailRow = {}
    this.selectedChartRow = data

    this.selectedChartType = 'daily'
    this.onSelectedChartType(this.selectedChartType)
  }

  @Watch('detailType')
  OnChangeDetailType() {
    this.onSelectedChartType(this.selectedChartType)
  }

  onOpenGraphModal(data) {
    console.log(data, 'onOpenGraphModal')
    this.selectedQARow = data
    this.modalVisible = true
  }

  onCloseModal() {
    // Edit modal
    this.modalVisible = false
  }

  onEditScenario(data) {
    console.log(data, 'onEditScenario')
  }

  onDetailAnswers(data) {
    this.selectedDetailRow = data
    if (data) {
      this.detailAnswers = data.items
    } else {
      this.detailAnswers = []
    }
    this.componentKeyDetailAnswers++
  }
}
